<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Applications</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Job Information</li>
                  <li class="breadcrumb-item active" v-if="display === 'all'">
                    All
                  </li>
                  <li
                    class="breadcrumb-item active"
                    v-else-if="display === 'active'"
                  >
                    Active
                  </li>
                  <li
                    class="breadcrumb-item active"
                    v-else-if="display === 'inactive'"
                  >
                    Inactive
                  </li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <div class="row">
                  <button
                    class="btn btn-primary dropdown-toggle m-1"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Status
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a class="dropdown-item" @click="getAllVacancies"
                      >All Vacancies</a
                    >
                    <a class="dropdown-item" @click="getActiveVacancies"
                      >Active Vacancies</a
                    >
                    <a class="dropdown-item" @click="getInactiveVacancies"
                      >Inactive Vacancies</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-between">
                    <h4 class="card-title mb-0">Job Information</h4>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <v-data-table
                      :headers="headers"
                      :items="vacancies"
                      sort-by=""
                      class="elevation-1"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <router-link
                              :to="{
                                name: 'vacancydetail',
                                params: { id: item.id }
                              }"
                              class="dropdown-item"
                              ><i class="fa fa-pencil m-r-5"></i>
                              Edit</router-link
                            >
                            <a
                              class="dropdown-item"
                              @click="setDeleteVacancy(item)"
                              ><i class="fa fa-trash-o m-r-5"></i> Close</a
                            >
                          </div>
                        </div>
                      </template>
                      <template v-slot:[`item.tit`]="{ item }">
                        <router-link :to="`/appvacancy/${item.id}`">
                          <span>{{ item.title }}</span></router-link
                        >
                      </template>
                      <template v-slot:[`item.applicationCount`]="{ item }">
                        <span>{{
                          item.acceptedApplicationCount +
                            item.aptitudeTestInterviewCount +
                            item.newApplicationCount +
                            item.rejectedApplicationCount +
                            item.medicalApplicationCount
                        }}</span>
                      </template>
                      <template v-slot:[`item.daysCount`]="{ item }">
                        <span>{{ getDays(item.periodFrom) }}</span>
                      </template>
                      <template v-slot:[`item.stat`]="{ item }">
                        <a
                          class="btn btn-white btn-sm btn-rounded"
                          v-if="item.status == 0"
                          aria-expanded="false"
                          >Inactive
                        </a>
                        <a
                          class="btn btn-white btn-sm btn-rounded"
                          v-if="item.status == 1"
                          aria-expanded="false"
                          >Active
                        </a>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Vacancy</h3>
                <p>Are you sure want to close this vacancy?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteVacancy"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Close</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="() => (dialog = false)"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { jobService } from "@/services/jobService";
import Vue from "vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Name",
          align: "start",
          value: "tit"
        },
        { text: "Applications", value: "applicationCount" },
        { text: "Days Open", value: "daysCount" },
        { text: "", value: "stat" }
      ],
      vacancies: [],
      activevacancy: {},
      display: "all",
      activevacancies: [],
      inactivevacancies: [],
      currentOffice: authenticationService.currentOfficeValue
    };
  },
  mounted() {
    this.getAllVacancies();
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },
  methods: {
    setDeleteVacancy(model) {
      (this.dialog = true), (this.activevacancy = model);
    },
    closeDelete() {
      this.dialog = false;
    },
    getDays(end) {
      // To set two dates to two variables
      var date2 = new Date();
      var date1 = new Date(end);

      // To calculate the time difference of two dates
      var Difference_In_Time = date2.getTime() - date1.getTime();

      // To calculate the no. of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      return parseInt(Difference_In_Days);
    },
    deleteVacancy() {
      this.activevacancy.status = 8;
      jobService.updateVacancy(this.activevacancy).then(
        a => {
          jobService.getVacancySummaries(this.currentOffice.id).then(p => {
            this.vacancies = p;
          });
        },
        error => {
          this.error = error;
        }
      );
    },
    getAllVacancies() {
      jobService.getVacancySummaries(this.currentOffice.id).then(p => {
        this.vacancies = p;
        this.display = "all";
      });
    },
    getActiveVacancies() {
      jobService.getVacancySummaries(this.currentOffice.id).then(p => {
        this.activevacancies = p.filter(a => a.status === 1);
        // console.log(this.activeapplications)
        this.vacancies = this.activevacancies;
        this.display = "active";
      });
    },
    getInactiveVacancies() {
      jobService.getVacancySummaries(this.currentOffice.id).then(p => {
        this.inactivevacancies = p.filter(a => a.status === 0);
        // console.log(this.inactiveapplications)
        this.vacancies = this.inactivevacancies;
        this.display = "inactive";
      });
    }
  },
  name: "vacancies"
};
</script>
<style scoped>
.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/applications/vacancies.vue